import type { FC } from "react"

import { DropdownField } from "commons"
import { ISelectItem } from "models"

const OnboardingStepPractitioner: FC<Props> = ({ practitioners }) => (
  <div className="flex flex-col gap-6 md:gap-8">
    <div>
      <h2 className="text-2xl leading-6 font-semibold text-gray-900">Select your practitioner</h2>
      <p className="text-base leading-5 text-gray-500 mt-2">Choose the practitioner who will take care of you</p>
    </div>
    <DropdownField field="practitioner" label="Practitioner" options={practitioners} />
  </div>
)

type Props = {
  practitioners: ISelectItem[]
}

export { OnboardingStepPractitioner }
